"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteProjectParticipantModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const ProjectParticipantsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectParticipantsProvider");
const PromiseUtils_1 = require("src/hello_assets/src/components/system/util/PromiseUtils");
const TextTruncated_1 = require("src/hello_assets/src/components/ui/common/common/TextTruncated");
const modalButtonsPropsInitialValue = {
    ok: { disabled: false, danger: true },
    cancel: {}
};
const DeleteProjectParticipantModalComponent = (props) => {
    var _a;
    const projectParticipantsContext = (0, ProjectParticipantsProvider_1.useProjectParticipantsContext)();
    const [deleteError, setDeleteError] = (0, react_1.useState)(undefined);
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const title = "Delete member";
    const okText = "Delete";
    const deleteCancellable = (0, PromiseUtils_1.makeCancelableAsync)(async () => {
        return await projectParticipantsContext.management.removeParticipant(props.projectView.projectApiKey, props.participantView.principal);
    });
    const asyncDelete = async () => {
        try {
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            try {
                await deleteCancellable.runAsyncFunc();
                props.onDestroy();
            }
            catch (e) {
                const { isCanceled, error } = e;
                if (isCanceled) {
                    return;
                }
                else {
                    throw error;
                }
            }
        }
        catch (error) {
            console.error("DeleteProjectParticipantModalComponent: delete failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            setDeleteError("Participant cannot be deleted. Please try again.");
        }
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        await asyncDelete();
    };
    return React.createElement(antd_1.Modal, { width: 550, closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, okText: okText, onOk: onOk, okButtonProps: modalButtonProps.ok, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal" },
        deleteError && React.createElement(antd_1.Alert, { message: deleteError, type: "error" }),
        "Are you sure you want to delete \"",
        React.createElement(TextTruncated_1.TextTruncated, { text: ((_a = props.participantView) === null || _a === void 0 ? void 0 : _a.name) || "", length: 40 }),
        "\" from \"",
        React.createElement(TextTruncated_1.TextTruncated, { text: props.projectView.projectName, length: 40 }),
        "\"?");
};
exports.DeleteProjectParticipantModalComponent = DeleteProjectParticipantModalComponent;
